import { EventDispatcher } from '../../events/EventDispatcher/EventDispatcher';

export class AsyncQueue {
  private readonly eventDispatcher = new EventDispatcher<{
    drained: undefined;
  }>();

  private queuedWorkers: Array<AsyncQueueWorker> = [];

  private isDraining: boolean = false;

  public add(worker: AsyncQueueWorker): void {
    this.queuedWorkers.push(worker);

    if (!this.isDraining) {
      void this.drain();
    }
  }

  public waitUntilDrained(): Promise<void> {
    if (this.isDraining) {
      return new Promise((resolve) => {
        this.eventDispatcher.addEventListener('drained', resolve);
      });
    }

    return Promise.resolve();
  }

  private async drain(): Promise<void> {
    this.isDraining = true;

    try {
      await this.executeRemainingWorkers();
    } finally {
      this.isDraining = false;
      this.eventDispatcher.dispatchEvent('drained', undefined);
    }
  }

  private async executeRemainingWorkers(): Promise<void> {
    const worker = this.queuedWorkers.shift();
    if (!worker) {
      return;
    }

    try {
      await worker();
    } finally {
      await this.executeRemainingWorkers();
    }
  }
}

export type AsyncQueueWorker = () => void | Promise<void>;
